import React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import { FaUsers, FaEuroSign, FaRocket, FaBriefcase, FaNetworkWired, FaCalendarAlt } from 'react-icons/fa';
import './WhyChooseSection.css';

const WhyChooseSection = () => {
  const organizationBenefits = [
    {
      icon: <FaUsers />,
      title: 'Accès aux meilleurs talents',
      description: 'Trouvez rapidement des professionnels qualifiés et expérimentés dans votre domaine sportif.'
    },
    {
      icon: <FaEuroSign />,
      title: 'Coûts maîtrisés',
      description: 'Optimisez votre budget avec des tarifs transparents et des missions à la carte.'
    },
    {
      icon: <FaRocket />,
      title: 'Rapidité de mise en relation',
      description: 'Publiez votre mission et recevez des candidatures qualifiées en quelques heures.'
    }
  ];

  const professionalBenefits = [
    {
      icon: <FaBriefcase />,
      title: 'Nouvelles opportunités',
      description: 'Découvrez des missions variées adaptées à vos compétences et votre expertise.'
    },
    {
      icon: <FaCalendarAlt />,
      title: 'Flexibilité totale',
      description: 'Choisissez vos missions selon vos disponibilités et vos préférences géographiques.'
    },
    {
      icon: <FaNetworkWired />,
      title: 'Développement du réseau',
      description: 'Élargissez votre réseau professionnel et construisez votre réputation dans le sport.'
    }
  ];

  return (
    <section className="why-choose-section">
      <Container maxWidth="lg">
        <Box className="why-choose-header">
          <Typography variant="h2" className="why-choose-title">
            Pourquoi choisir Mission Sport ?
          </Typography>
          <Typography variant="body1" className="why-choose-subtitle">
            Des avantages concrets pour tous les acteurs du sport
          </Typography>
        </Box>

        <Grid container spacing={6} className="benefits-container">
          {/* Avantages pour les organisations */}
          <Grid item xs={12} lg={6}>
            <Box className="benefits-column">
              <div className="benefits-image">
                <img 
                  src="https://images.unsplash.com/photo-1552674605-db6ffd4facb5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                  alt="Équipe d'organisation sportive"
                  className="benefit-img"
                />
              </div>
              <Typography variant="h3" className="benefits-title">
                Pour les organisations
              </Typography>
              <div className="benefits-list">
                {organizationBenefits.map((benefit, index) => (
                  <Box key={index} className="benefit-item">
                    <div className="benefit-icon">
                      {benefit.icon}
                    </div>
                    <div className="benefit-content">
                      <Typography variant="h4" className="benefit-title">
                        {benefit.title}
                      </Typography>
                      <Typography variant="body2" className="benefit-description">
                        {benefit.description}
                      </Typography>
                    </div>
                  </Box>
                ))}
              </div>
            </Box>
          </Grid>

          {/* Avantages pour les professionnels */}
          <Grid item xs={12} lg={6}>
            <Box className="benefits-column">
              <div className="benefits-image">
                <img 
                  src="https://images.unsplash.com/photo-1594736797933-d0401ba2fe65?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                  alt="Professionnel du sport en action"
                  className="benefit-img"
                />
              </div>
              <Typography variant="h3" className="benefits-title">
                Pour les professionnels
              </Typography>
              <div className="benefits-list">
                {professionalBenefits.map((benefit, index) => (
                  <Box key={index} className="benefit-item">
                    <div className="benefit-icon">
                      {benefit.icon}
                    </div>
                    <div className="benefit-content">
                      <Typography variant="h4" className="benefit-title">
                        {benefit.title}
                      </Typography>
                      <Typography variant="body2" className="benefit-description">
                        {benefit.description}
                      </Typography>
                    </div>
                  </Box>
                ))}
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default WhyChooseSection;